'use client';
import { useState, useEffect } from 'react';
import { createClient } from '@/lib/supabase/client';

const TOTAL_SPOTS = 500;

export interface SpotsData {
  spotsTaken: number;
  spotsRemaining: number;
  totalSpots: number;
  isLoaded: boolean;
}

export function useLiveSpots(): SpotsData {
  const [spotsTaken, setSpotsTaken] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const supabase = createClient();

    const fetchSpots = async () => {
      const { count } = await supabase
        .from('members')
        .select('id', { count: 'exact', head: true })
        .eq('payment_status', 'paid');

      if (count !== null) {
        setSpotsTaken(count);
        setIsLoaded(true);
      }
    };

    fetchSpots();

    // Real-time subscription: re-fetch whenever members table changes
    const channel = supabase
      .channel('live_spots_members')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'members' },
        () => {
          fetchSpots();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  return {
    spotsTaken,
    spotsRemaining: TOTAL_SPOTS - spotsTaken,
    totalSpots: TOTAL_SPOTS,
    isLoaded,
  };
}
